







































































































































































































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import E404 from "@service/views/errors/e404.vue";
import {repositories} from "@service/api/Repositories";
import {RepositoryFabric} from "@api/repositories/RepositoryFabric";
import {UserProfile} from "@api/models/UserProfile";
import {Problem} from "@api/models/tickets/Problem";
import {Idea} from "@api/models/tickets/Idea";
import {FilesPayload} from "@share/common/form/form-controls/file/DragNDrop.vue";
import {AppercodeFile} from "@api/models/File";
import CommentsView from "./Comments.vue";
import ObjectLayout from "@service/layouts/ObjectViewLayout.vue";
import BounceSpinner from "@share/common/BounceSpinner.vue";
import { formatDate } from "@common/dateTimeHelper";
import { hexToRGB } from "@common/colorHelper";
import {TicketType} from "@share/ticketSystem/enums/TicketTypes";
import {TicketSchema} from "@share/ticketSystem/enums/TicketSchemas";
import { TicketService } from '@share/common/services/ticket/TicketService';
import Speaker from '@share/session/components/Speaker.vue';
import ItemsList from "@share/common/ItemsList.vue";
import {process as processText} from '@common/MessageProcessor';
import Description from "@share/common/Description.vue";
import {EventBus} from '@common/EventBus';
import {Element} from "@api/models/Element";
import {TicketStatus} from "@api/models/TicketStatus";
import { getFileUrl } from '@api/helpers/url/imageUrl';
import { FileRepository } from "@api/repositories/FileRepository";
import { RouteNamesEnum } from '@service/router/RouteNamesEnum';
import OtherFileSvg from '../../../assets/svg/other-file.svg';
import ExcelSvg from '../../../assets/svg/excel.svg';
import WordSvg from '../../../assets/svg/word.svg';
import PdfSvg from '../../../assets/svg/pdf-r.svg';
import PptSvg from '../../../assets/svg/ppt.svg';
import ArrowSvg from '../../../assets/svg/arrow-rounded.svg';
import CloseSvg from '../../../assets/svg/close-rounded.svg';
import { getImageUrlByBackend } from '@api/helpers/url/imageUrl';
import { DateTime } from "luxon";
import { TicketTableHelper } from '../helpers/TicketTableHelper';
import { Ticket } from '@api/models/tickets/Ticket';
import { getCurrencyMask } from "@share/common/form/form-controls/text/masks";

const currencyMask = getCurrencyMask();

@Component({
    components: {
        E404, CommentsView, ObjectLayout, BounceSpinner, Speaker, ItemsList,
        Description, ArrowSvg, CloseSvg
    }
})

export default class TicketView extends Vue {
    @Prop({default: {}}) params: {
        ticketsType: TicketType;
        ticketService: TicketService;
        ticketHelper: TicketTableHelper;
        onlyOwn: boolean;
    };
    @Prop() id: string;
    @Prop({default: false}) disableNavigation: boolean;


    private readonly CODE_FOR_REVISION = 'forRevision';
    private readonly MIN_VISIBLE_FILES = 3;
    private readonly MIN_VISIBLE_IMAGES = 4;

    ticket?: Problem | Idea | null = null;
    categories: Element[] = [];
    statuses: TicketStatus[] = [];
    files: FilesPayload = [];
    imageFiles: FilesPayload = [];
    users: { [key: string]: UserProfile } = {};
    showAllFiles = false;
    showAllImages = false;

    notFoundError = false;
    isLoading = true;

    getFormatedCurrencyString(value: string) {
        return currencyMask.resolve(value)
    }

    get ticketService() {
        return this.params.ticketService;
    }

    get fileRepository() {
        return repositories.get<FileRepository>(RepositoryFabric.FILE);
    }

    get createdAt() {
        if (this.ticket?.createdAt && this.ticket.createdAt instanceof DateTime) {
            return formatDate(this.ticket.createdAt, this.lang);
        }
        return '';
    }

    get implementedAt() {
        if (this.ticket?.implementedAt) {
            return formatDate(DateTime.fromISO(this.ticket.implementedAt), this.lang);
        }
        return '';
    }

    get plannedImplementationDate() {
        if (this.ticket?.plannedImplementationDate) {
            return formatDate(DateTime.fromISO(this.ticket.plannedImplementationDate), this.lang);
        }
        return '';
    }

    get description() {
        return processText(this.ticket?.description);
    }

    get solution() {
        return processText(this.ticket?.solution);
    }

    get effectFormation() {
        return processText(this.ticket?.effectFormation);
    }

    async mounted() {
        await this.load();
    }

    @Watch('ticketId')
    async load() {
        this.isLoading = true;
        this.showAllFiles = false;
        this.showAllImages = false;
        try {
            const [categories, statuses] = await Promise.all([
                this.ticketService.getCategories(this.ticketType),
                this.ticketService.getStatuses(this.ticketType)
            ]);
            this.categories = categories ?? [];
            this.statuses = statuses as TicketStatus[] ?? [];

            if (this.ticketId) {
                this.ticket = await this.ticketService.getTicketById(this.ticketType, this.ticketId);

                if (this.ticket) {
                    const [files, imageFiles] = await Promise.all([
                        this.getFilesForField('fileIds'),
                        this.getFilesForField('imageFileIds'),
                    ]);
                    this.files = files;
                    this.imageFiles = imageFiles;
                    const users = await this.ticketService.getTicketsUsers([this.ticket], {take: -1});

                    users.forEach((user: UserProfile) => {
                        if(user?.userId) {
                            this.users[user.userId] = user;
                        }
                    });
                }
                else {
                    this.show404();
                }
            } else {
                this.show404();
            }
        } catch(e) {
            if ((e as Error).message.includes('404')) {
                this.show404();
            } else {
                this.$store.dispatch('reportException', e, {root: true});
            }
        } finally {
            this.isLoading = false;
        }
    }

    async getFilesForField(fieldName: string) {
        let files: FilesPayload = [];
        if (this.ticket && this.ticket[fieldName]) {

            if (Array.isArray(this.ticket[fieldName]) && !this.ticket[fieldName].length) {
                return files;
            }

            (this.fileRepository as any).query({ids: this.ticket[fieldName]}).then((filesFromServer: AppercodeFile[]) => {
                if (filesFromServer) {
                    filesFromServer.forEach((file: AppercodeFile) => {
                        files.push({file, url: ''});
                    });
                }
            });
        }

        return files;
    }

    get schemaId() {
        return this.ticketType === TicketType.idea ? TicketSchema.idea : TicketSchema.problem;
    }

    show404() {
        this.notFoundError = true;
    }

    get ticketId(): string | null {
        return this.id || this.$route.params.id
    }

    get ticketType(): TicketType {
        return this.params.ticketsType;
    }

    get backend() {
        return this.$store.state.session.backend;
    }

    get author() {
        return this.ticket?.ownerIds ? this.users[this.ticket?.ownerIds[0]] : undefined;
    }

    get responsibleUser() {
        return this.ticket?.responsibleUserId  ? this.users[this.ticket?.responsibleUserId] : undefined;
    }

    get responsibleUserForImplementation() {
        return this.ticket?.responsibleForImplementationUserId  ? this.users[this.ticket?.responsibleForImplementationUserId] : undefined;
    }

    get status() {
        if (this.ticket && this.statuses?.length > 0) {
            return this.statuses.filter(status => status.id === this.ticket?.status)?.[0] || null;
        }
        return null;
    }

    get category() {
        if (this.ticket && this.categories?.length > 0) {
            return this.categories.filter(category => category.id === this.ticket?.category)?.[0]?.title || '';
        }
        return '';
    }

    get filesList() {
        return this.showAllFiles ? this.files : this.files.slice(0, this.MIN_VISIBLE_FILES);
    }

    get imageList() {
        return this.showAllImages ? this.imageFiles : this.imageFiles.slice(0, this.MIN_VISIBLE_IMAGES);
    }

    get isShowMoreFilesControlVisible() {
        return this.MIN_VISIBLE_FILES < this.files.length;
    }

    get isShowMoreImagesControlVisible() {
        return this.MIN_VISIBLE_IMAGES < this.imageFiles.length;
    }

    get isIdea() {
        return this.ticketType === TicketType.idea;
    }

    get isProblem() {
        return this.ticketType === TicketType.problem;
    }

    private get lang() {
        return this.$store.state.session.language ?? 'en';
    }

    processText(text: string) {
        return processText(text);
    }

    select(user: UserProfile | undefined) {
        if (this.$store.getters['userId'] !== user?.userId) {
            EventBus.$emit("showChatByUserId", user?.userId);
        }
    }

    getFileUrl(id: string, name?: string) {
        return getFileUrl(this.backend, id, name);
    }

    openFile(id: string, name?: string) {
        window && window.open(this.getFileUrl(id, name), '_blank');
    }

    editTicket() {
        let toRoute

        if(!this.params.ticketsType) {
            toRoute = this.$route.name === RouteNamesEnum.ticketSystemIdeaView
            ? RouteNamesEnum.ticketSystemIdeaEdit : RouteNamesEnum.ticketSystemProblemEdit;
        }
        else {
            toRoute = this.params.ticketsType === TicketType.idea
            ? RouteNamesEnum.ticketSystemIdeaEdit : RouteNamesEnum.ticketSystemProblemEdit;
        }

        //TODO: There is need to make wrapper for emiting event "toEdit" (for example) for different parent components
        this.$router.push({
            name: toRoute,
            hash: this.$route.hash,
            params: {
                id: this.id || this.$route.params.id
            }
        });
    }

    get isAdmin() {
        return !!this.params.ticketService?.isAdmin;
    }

    // идентификатор статуса На доработку
    get idForRevisionStatus() {
        return this.statuses.find(s => s.code.indexOf(this.CODE_FOR_REVISION) !== -1)?.id;
    }

    get isEditEnabled() {
        return this.isAdmin || this.ticket?.ownerIds?.includes(this.$store.getters.userId)
            && this.ticket.status === this.idForRevisionStatus;
    }

    fileIcon(filename: string) {
        const index = filename.lastIndexOf('.');
        const ext = filename.slice(index + 1);
        switch(ext) {
            case 'xls':
            case 'xlsx':
                return ExcelSvg;
            case 'doc':
            case 'docx':
                return WordSvg;
            case 'pdf':
                return PdfSvg;
            case 'ppt':
            case 'pptx':
                return PptSvg;
        }
        return OtherFileSvg;
    }

    imageSource(fileId: string) {
        return getImageUrlByBackend(this.backend, fileId);
    }

    get isCommentsReadOnly() {
        return this.$store.getters['userId'] !== this.ticket?.ownerId && this.$store.getters['userId'] !== this.ticket?.responsibleUserId && !this.isAdmin;
    }

    // индекс текущего тикета в списке
    get indexInList() {
        return this.params.ticketHelper.list.findIndex((ticket: Ticket) => ticket.id === this.ticketId);
    }

    get isAvailableNextTicket() {
        return this.indexInList < this.params.ticketHelper.list.length - 1;
    }

    get isAvailablePrevTicket() {
        return this.indexInList > 0;
    }

    nextTicket() {
        if (this.isAvailableNextTicket && this.$route.name !== null) {
            this.$router.push({
                name: this.$route.name,
                hash: this.$route.hash,
                params: {
                    id: this.params.ticketHelper.list[this.indexInList + 1].id
                }
        });
        }
    }

    prevTicket() {
        if (this.isAvailablePrevTicket && this.$route.name !== null) {
            this.$router.push({
                name: this.$route.name,
                hash: this.$route.hash,
                params: {
                    id: this.params.ticketHelper.list[this.indexInList - 1].id
                }
        });
        }
    }

    get statusStyles() {
        if (!this.status?.color) {
            return {};
        }
        return {
            color: this.status.color,
            background: `linear-gradient(0deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.03)), ${hexToRGB(this.status.color, 0.2)} `
        }
    }
}
